<template>
   <footer
      aria-labelledby="footer-heading"
      class="mt-auto border-t border-gray-25"
   >
      <div class="flex flex-col items-center">
         <div class="container px-8 md:px-4 lg:px-14 mt-5 lg:mt-14">
            <div class="flex flex-col gap-2">
               <div>
                  <img
                     :src="DefaultAssets.images.logo"
                     class="w-36 md:w-40"
                     :alt="`TalkTime Logo `"
                  />
               </div>
               <p class="text-md mt-3 text-gray-900 font-bold">
                  {{ $t('footer.help_question') }}
               </p>
               <div class="text-gray-200 text-sm">
                  {{ $t('footer.help_description') }}
               </div>
               <div class="flex flex-wrap gap-4">
                  <a
                     href="mailto:customercare@talktime.ae"
                     class="cursor-pointer text-primary-500 underline"
                  >
                     customercare@talktime.ae
                  </a>
                  <a
                     href="tel:+971048369411"
                     class="cursor-pointer text-primary-500 underline"
                  >
                     +971048369411
                  </a>
               </div>
               <div class="flex mt-3 flex-wrap gap-4">
                  <a href="https://apps.apple.com/ae/app/talktime-premium-therapy/id6745527693" target="_blank" aria-label="Download on the App Store">
                     <img src="/image/Apple.svg" alt="App Store" class="h-10" />
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=talktime.ae&pli=1" target="_blank" aria-label="Get it on Google Play">
                     <img src="/image/Google.svg" alt="Google Play" class="h-10" />
                  </a>
               </div>
            </div>
         </div>
         <div class="mt-5 bg-primary-50 w-full py-3 flex flex-col items-center">
            <p
               class="text-xs text-gray-200 font-medium px-8 md:px-4 lg:px-14 container"
            >
               {{ $t('footer.copyright') }}
            </p>
         </div>
      </div>
   </footer>
</template>

<script setup>
   import { DefaultAssets } from '~/assets/DefaultAssets';
</script>
